var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("登录日志")])]),_c('div',[_vm._v("这里后续实现登录日志查询与查看功能。")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }